import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@asset-metrix/portal-ui';
import { Stack, Text } from '@mantine/core';

import styles from './dashboard-modals.module.scss';

type DashboardDeleteConfirmationProps = {
  opened: boolean;
  dashboardName: string;
  loading?: boolean;
  /** Overrides the default staged-delete warning used by All Dashboards. */
  warningMessage?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DashboardDeleteConfirmation({
  opened,
  dashboardName,
  loading,
  warningMessage,
  onCancel,
  onConfirm,
}: DashboardDeleteConfirmationProps) {
  const { t } = useTranslation();

  return (
    <Modal
      actions={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {t('app.dashboard.deleteConfirmation.cancel')}
          </Button>
          <Button loading={loading} onClick={onConfirm}>
            {t('app.dashboard.deleteConfirmation.confirm')}
          </Button>
        </>
      }
      data-testid="dashboard-delete-confirmation-modal"
      modalType="action"
      opened={opened}
      onClose={onCancel}
      size={420}
      title={t('app.dashboard.deleteConfirmation.title')}
      zIndex={400}
    >
      <Stack className={styles.deleteConfirmMessage} gap="md">
        <Text component="p" m={0}>
          {t('app.dashboard.deleteConfirmation.message', { dashboardName })}
        </Text>
        <Text>
          {warningMessage ??
            t('app.dashboard.deleteConfirmation.irreversibleWarning')}
        </Text>
      </Stack>
    </Modal>
  );
}
